import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "editor"]
  static values = { field: String }

  toggle(event) {
    event.preventDefault()
    const locale = event.currentTarget.dataset.locale
    const editor = this.editorTargets.find(el => el.dataset.locale === locale)

    if (editor) {
      editor.classList.toggle("hidden")
    }
  }
}
